// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 계정 관련 입력 박스 */
.auth-input-box {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  height: 64px;
  padding: 16px;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--background-disable-color);
  background: #FFF;
}

.auth-input-box.login {
  margin-top: 14px;
}

.auth-input-box.cert {
  width: calc(100% - 168px);
}

.auth-input-box.login.readonly {
  background-color: #F2F3F7;
}

.auth-input-box.cert.readonly {
  background-color: #F2F3F7;
}

.auth-input-box.cert.disable {
  background-color: #F2F3F7;
  border: 1px solid #C9CAD3;
}

.auth-input-box.error {
  border: 1px solid var(--error-color);
}

.auth-input-box.auto {
  border: 1px solid var(--main-color);
}

.auth-input-box>span {
  color: var(--main-color);
  font-family: 'Pretendard Medium', sans-serif;
}

.auth-input-box.login>input {
  width: calc(100% - 36px);
  height: 100%;
}

.auth-input-box.cert>input {
  width: 100%;
  height: 100%;
}

.auth-input-box.cert.disable>input {
  color: #ADB0B8;
}

.auth-input-box.login>img {
  margin-left: 8px;
  width: 32px;
  height: 32px;
  cursor: pointer;
}

.auth-input-message-box {
  margin-top: 8px;
  display: flex;
  gap: 8px;
  width: 100%;
  color: var(--error-color);
  white-space: pre-line;
}

.auth-input-message-box>img {
  margin-top: 2px;
  width: 16px;
  height: 16px;
}

.auth-check-box-neis {
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.auth-check-box-neis>img {
  width: 20px;
  height: 20px;
  cursor: pointer;
}



/* 계정 셀렉트 박스 */
.auth-select-box {
  margin-top: 14px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 64px;
  padding: 0 18px;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--background-disable-color);
  background: #FFF;
  cursor: pointer;
  font-size: 18px;
  color: #9295A0;
}

.auth-select-box.disable {
  background-color: #F2F3F7;
}

.common-button {
  display: flex;
  width: 100%;
  height: 64px;
  justify-content: center;
  align-items: center;
  border-radius: 32px;
  background: #3F0AB1;
  color: white;
  font-size: 20px;
  cursor: pointer;
  font-family: 'Pretendard Medium', sans-serif;
}

.common-button.double {
  width: calc(50% - 5px);
}

.common-button.white {
  border: 1px solid var(--main-color);
  color: var(--main-color);
  background-color: white
}

.common-button.disable {
  border: 1px solid var(--background-disable-color);
  color: var(--text-disable-color);
  background-color: var(--background-disable-color);
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/pages/service/auth/auth.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;;;AAIA,cAAc;AACd;EACE,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iDAAiD;EACjD,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB;AACF;;AAEA;EACE,iDAAiD;EACjD,gCAAgC;EAChC,iDAAiD;EACjD,mBAAmB;AACrB","sourcesContent":["/* 계정 관련 입력 박스 */\n.auth-input-box {\n  box-sizing: border-box;\n  display: flex;\n  width: 100%;\n  height: 64px;\n  padding: 16px;\n  align-items: center;\n  border-radius: 8px;\n  border: 1px solid var(--background-disable-color);\n  background: #FFF;\n}\n\n.auth-input-box.login {\n  margin-top: 14px;\n}\n\n.auth-input-box.cert {\n  width: calc(100% - 168px);\n}\n\n.auth-input-box.login.readonly {\n  background-color: #F2F3F7;\n}\n\n.auth-input-box.cert.readonly {\n  background-color: #F2F3F7;\n}\n\n.auth-input-box.cert.disable {\n  background-color: #F2F3F7;\n  border: 1px solid #C9CAD3;\n}\n\n.auth-input-box.error {\n  border: 1px solid var(--error-color);\n}\n\n.auth-input-box.auto {\n  border: 1px solid var(--main-color);\n}\n\n.auth-input-box>span {\n  color: var(--main-color);\n  font-family: 'Pretendard Medium', sans-serif;\n}\n\n.auth-input-box.login>input {\n  width: calc(100% - 36px);\n  height: 100%;\n}\n\n.auth-input-box.cert>input {\n  width: 100%;\n  height: 100%;\n}\n\n.auth-input-box.cert.disable>input {\n  color: #ADB0B8;\n}\n\n.auth-input-box.login>img {\n  margin-left: 8px;\n  width: 32px;\n  height: 32px;\n  cursor: pointer;\n}\n\n.auth-input-message-box {\n  margin-top: 8px;\n  display: flex;\n  gap: 8px;\n  width: 100%;\n  color: var(--error-color);\n  white-space: pre-line;\n}\n\n.auth-input-message-box>img {\n  margin-top: 2px;\n  width: 16px;\n  height: 16px;\n}\n\n.auth-check-box-neis {\n  margin-top: 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.auth-check-box-neis>img {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n\n\n\n/* 계정 셀렉트 박스 */\n.auth-select-box {\n  margin-top: 14px;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  height: 64px;\n  padding: 0 18px;\n  align-items: center;\n  border-radius: 8px;\n  border: 1px solid var(--background-disable-color);\n  background: #FFF;\n  cursor: pointer;\n  font-size: 18px;\n  color: #9295A0;\n}\n\n.auth-select-box.disable {\n  background-color: #F2F3F7;\n}\n\n.common-button {\n  display: flex;\n  width: 100%;\n  height: 64px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 32px;\n  background: #3F0AB1;\n  color: white;\n  font-size: 20px;\n  cursor: pointer;\n  font-family: 'Pretendard Medium', sans-serif;\n}\n\n.common-button.double {\n  width: calc(50% - 5px);\n}\n\n.common-button.white {\n  border: 1px solid var(--main-color);\n  color: var(--main-color);\n  background-color: white\n}\n\n.common-button.disable {\n  border: 1px solid var(--background-disable-color);\n  color: var(--text-disable-color);\n  background-color: var(--background-disable-color);\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
